import { validateName, validateTitle } from "./validateCredentials";

export interface ProfileValidationData {
    name: string;
    title?: string;
  }
  
  export const validateProfileData = (data: ProfileValidationData): Record<string, string> => {
    const errors: Record<string, string> = {};
    
    const nameError = validateName(data.name);
    const titleError = validateTitle(data.title);
    
    if (nameError) errors.name = nameError;
    if (titleError) errors.title = titleError;
    
    return errors;
  };